<div class="flex flex-col">
    <img src="https://storage.googleapis.com/dexfreight-webapp-assets/Loadboad-Network/assets/LBN_StackedTM.png" alt="LBN" height="150" width="150">
    <!-- <div class="text-gray-400 font-extrabold" [class]="'text-' + size">LOADBOARD</div>
    <div class="text-dxf-blue font-extrabold" [class]="'text-' + size">NETWORK</div> -->
</div>